import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@repo/ui/components/ui/dialog";
type BiometricOptInDialogProps = {
  open: boolean;
  label: string;
  pending: boolean;
  onEnable: () => void;
  onDecline: () => void;
};
export function BiometricOptInDialog(t0) {
  const $ = _c(17);
  const {
    open,
    label,
    pending,
    onEnable,
    onDecline
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <DialogHeader><DialogTitle>Sign in with {label}</DialogTitle><DialogDescription>Use {label} to sign in faster next time?</DialogDescription></DialogHeader>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onDecline || $[3] !== pending) {
    t2 = <Button type="button" variant="outline" data-testid="biometric-opt-in-decline" disabled={pending} onClick={onDecline}>Not now</Button>;
    $[2] = onDecline;
    $[3] = pending;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onEnable || $[6] !== pending) {
    t3 = <Button type="button" data-testid="biometric-opt-in-enable" disabled={pending} onClick={onEnable}>Enable</Button>;
    $[5] = onEnable;
    $[6] = pending;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <DialogFooter>{t2}{t3}</DialogFooter>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t4) {
    t5 = <DialogContent CloseButton={null} onPointerDownOutside={_temp2} onEscapeKeyDown={_temp3}>{t1}{t4}</DialogContent>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== open || $[15] !== t5) {
    t6 = <Dialog open={open} onOpenChange={_temp}>{t5}</Dialog>;
    $[14] = open;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}
function _temp3(event_0) {
  return event_0.preventDefault();
}
function _temp2(event) {
  return event.preventDefault();
}
function _temp() {}